module.exports = __webpack_public_path__ + "img/c.1b4202c7.png";